import * as React from 'react';

function IconSeeMore(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.23 14a2.001 2.001 0 110-4.002 2.001 2.001 0 010 4.002zm6.771 0a2 2 0 110-4 2 2 0 010 4zm6.77 0a2 2 0 110-4.001 2 2 0 010 4.001z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconSeeMore = React.memo(IconSeeMore);
export default MemoIconSeeMore;
